import React, { Fragment, useState } from "react";

import GreenLogo from "../Innovators/GreenLogo";
import RedLogo from "../Mentors/RedLogo";
import BlueLogo from "../Employers/BlueLogo";

const DeleteAccount = ({ user, setShowDeleteAccount, deleteAccount }) => {
  const [formData, setFormData] = useState({
    password: "",
  });

  const { password } = formData;

  const [confirmDelete, setConfirmDelete] = useState(false);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== "") {
      deleteAccount(password);
      setShowDeleteAccount(false);
    }
  };

  return (
    <Fragment>
      <div className="subscription-overlay">
        <div className="subscription-box-confirmation">
          <i
            className={`far fa-times-circle ${
              user && user.role === "innovator"
                ? "green"
                : user && user.role === "mentor"
                ? "red"
                : user && user.role === "employer"
                ? "blue"
                : !user.role
                ? "green"
                : ""
            } fa-3x subscription-x`}
            onClick={() => {
              setShowDeleteAccount(false);
            }}
          ></i>
          <div className="subscription-type-container">
            {user && user.role === "innovator" && (
              <p className="nav-logo">
                <GreenLogo />
              </p>
            )}
            {user && !user.role && (
              <p className="nav-logo">
                <GreenLogo />
              </p>
            )}
            {user && user.role === "mentor" && (
              <p className="nav-logo">
                <RedLogo />
              </p>
            )}
            {user && user.role === "employer" && (
              <p className="nav-logo">
                <BlueLogo />
              </p>
            )}
            {user && user.role && (
              <h1
                className={`subscription-name ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                WARNING!
              </h1>
            )}
          </div>
          {user && user.role && (
            <div className="sub-grid-three">
              <div className="sub-container">
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div
                      className={`avi-color-border-alt ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                          user && user.avatar
                        }`}
                        className="sub-avi"
                      />
                    </div>
                  </div>
                  <div className="online-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span
                          className={`${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          } name-font bold`}
                        >
                          {user.channelid}
                        </span>
                      </li>
                      <li className="user-online-item">
                        {user && user.firstname}
                      </li>
                      <li className="user-online-item">
                        {user && user.jobtitle}
                      </li>
                      <li className="user-online-item">
                        {user.location && user.location.state},{" "}
                        {user.location && user.location.country}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!confirmDelete && (
            <div>
              <div className="sub-grid">
                <p className="user-request-text white">
                  <span className="red bold">WARNING!</span> Once you delete
                  your account, your account will be permanently deleted and all
                  purchases and privileges will be lost.{" "}
                  <span className="red bold">
                    ARE YOU SURE YOU WOULD LIKE TO PERMANENTLY DELETE YOUR
                    ACCOUNT?
                  </span>
                </p>
              </div>
              <div className="flex-center">
                <button
                  onClick={() => {
                    setConfirmDelete(true);
                  }}
                  className="user-request-button background-red"
                >
                  <i className="fa-solid fa-user-xmark fa-sm mr-5"></i>
                  Delete Account
                </button>
                <button
                  onClick={() => {
                    setShowDeleteAccount(false);
                  }}
                  className="user-request-button background-red"
                >
                  <i className="fas fa-times fa-sm mr-5 bold"></i>
                  Cancel
                </button>
              </div>
            </div>
          )}
          {confirmDelete && (
            <div>
              <div className="user-request-text white">
                Enter your password to confirm and delete your account:
              </div>
              <form
                className="form-control"
                method="POST"
                onSubmit={(e) => onSubmit(e)}
              >
                <label
                  htmlFor="email"
                  className={`delete-account-labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  *Enter Password:
                </label>
                <input
                  className="delete-account-input"
                  type="password"
                  name="password"
                  placeholder="Enter Password"
                  onChange={(e) => onChange(e)}
                />
                <div className="flex-center">
                  <button className="user-request-button background-red">
                    <i className="fa-solid fa-user-xmark fa-sm mr-5"></i>
                    Delete Account
                  </button>
                  <button
                    onClick={() => {
                      setShowDeleteAccount(false);
                      setConfirmDelete(false);
                    }}
                    className="user-request-button background-red"
                  >
                    <i className="fas fa-times fa-sm mr-5 bold"></i>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default DeleteAccount;
